// extracted by mini-css-extract-plugin
export var highlightOriginal = "_5w-0";
export var highlightSuggested = "_5w-1";